import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

// GET ALL
export const fetchMedicine = createAsyncThunk(
  "doctor/fetchMedicine",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.GET_MEDICINE, {
        params: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// CREATE
export const createMedicine = createAsyncThunk(
  "doctor/createMedicine",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_MEDICINE,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const MedicineSlice = createSlice({
  name: "medicine",
  initialState: {
    fetch: { data: [], loading: false, error: null, success: false },
    create: { data: null, loading: false, error: null, success: false },
  },
  reducers: {
    resetCreateState: (state) => {
      state.create.data = null;
      state.create.error = null;
      state.create.success = false;
    },
    resetFetchState: (state) => {
      state.fetch.data = [];
      state.fetch.error = null;
      state.fetch.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchMedicine.pending, (state) => {
        state.fetch.loading = true;
        state.fetch.error = null;
        state.fetch.success = false;
      })
      .addCase(fetchMedicine.fulfilled, (state, action) => {
        state.fetch.loading = false;
        state.fetch.data = action.payload || [];
        state.fetch.success = true;
      })
      .addCase(fetchMedicine.rejected, (state, action) => {
        state.fetch.loading = false;
        state.fetch.error = action.payload;
        state.fetch.success = false;
      })

      // CREATE
      .addCase(createMedicine.pending, (state) => {
        state.create.loading = true;
        state.create.error = null;
        state.create.success = false;
      })
      .addCase(createMedicine.fulfilled, (state, action) => {
        state.create.loading = false;
        state.create.data = action.payload;
        state.create.success = true;
      })
      .addCase(createMedicine.rejected, (state, action) => {
        state.create.loading = false;
        state.create.error = action.payload;
        state.create.success = false;
      });
  },
});

export const { resetCreateState, resetFetchState } = MedicineSlice.actions;

export default MedicineSlice.reducer;
